import { Card, Col, Empty, Row, Segmented, Statistic } from 'antd';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import React, { useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';
import { CollectionServer, errorCatch, GET, JSXMap, QueryDetail, QueryOrder, QueryParam, READWITH } from 'fennec-ui';
import REDUX_AkkauntiPolzovatelei from '../../../objects/AkkauntiPolzovatelei/reducer';
import "react-lightbox-pack/dist/index.css";
import Collection from '../../../common/Collection';
import Icofont from 'react-icofont';
import { useAuth } from 'fennec-ui';
import PageLayout from '../../components/PageLayout';
import { useMemo } from 'react';
import { Tabs } from 'antd';
import OstatkiPoSchetu from '../../forms/OstatkiPoSchetu';
import FilterFieldLabel from '../../components/FilterFieldLabel';

dayjs.locale('ru');

var _ = require('lodash');


const useStyles = createUseStyles({
	item: {
		padding: "5px 10px",
		display: "flex",
		cursor: "pointer",
		'&:hover': {
			backgroundColor: "#f9f9f9"
		}
	},
	block: {
		'& .buttons': {
			marginBottom: "10px"
		},
	},
	ticket: {
		padding: "5px 10px",
		'&:hover': {
			backgroundColor: "#f9f9f9"
		}
	},
	ticketHeader: {
	},
	ticketName: {

	},
	collapsePanel: {
		'& .ant-collapse-content > .ant-collapse-content-box': {
			padding: "6px"
		},
		'&.ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box': {
			paddingTop: "0px",
			paddingBottom: "0px"
		}
	}
})

function getCurrencyValue(value, color) {
	if (!value) {
		return (<span style={{ color: "grey" }}>
			{(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
		</span>)
	}
	if (color) {
		return (<span style={{ color: color }}>
			{(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
		</span>)
	}
	if (value >= 0) {
		return (<span style={{ color: "rgb(63, 134, 0)" }}>
			{(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
		</span>)
	}
	if (value < 0) {
		return (<span style={{ color: "red" }}>
			{(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
		</span>)
	}
}

function Account(props) {
	const classes = useStyles();
	const { auth, account } = props;

	const balance = (e) => {
		let v = _.get(e, "akkaunt.ostatok")
		if (v) return v;
		return 0;
	};

	const volume = balance(account);

	const [panel, setPanel] = React.useState('dvizheniya');
	const filters = () => [
		{
			label: "Дата создания",
			name: "CreatedAt",
			filterType: "range",
			// func: ["min", "max"],
			sort: true,
			filter: true,
			sorted: "DESC",
		},
		{
			label: "Тип счета списания",
			name: "ukhod.akkauntType",
			filterType: "group",
			queryFilter: [
				QueryDetail("model"),
				QueryOrder("code", "ASC"),
				QueryParam("w-neq-id", "7")
			],
			display: (o) => o.opisanie,
			sort: true,
			filter: true,
		},
		{
			label: "Номер счета списания",
			name: "ukhod.nomerAkkaunta",
			sort: true,
			filter: true,
		},
		{
			label: <FilterFieldLabel label="Владелец счета списания" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
			name: "ukhod.accountInfo.vladelets",
			// queryComparer:"swsim", // sim, wsim, swsim
			sort: true,
			filter: true,
		},
		{
			label: "Сумма операции",
			name: "summa",
			filterType: "range",
			func: ["min", "max"],
			sort: true,
			filter: true,
		},
		{
			label: "Тип счета зачисления",
			name: "prikhod.akkauntType",
			filterType: "group",
			queryFilter: [
				QueryDetail("model"),
				QueryOrder("code", "ASC"),
				QueryParam("w-neq-id", "7")
			],
			display: (o) => o.opisanie,
			sort: true,
			filter: true,
		},
		{
			label: "Номер счета зачисления",
			name: "prikhod.nomerAkkaunta",
			sort: true,
			filter: true,
		},
		{
			label: <FilterFieldLabel label="Владелец счета зачисления" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
			name: "prikhod.accountInfo.vladelets",
			// queryComparer:"swsim", // sim, wsim, swsim
			sort: true,
			filter: true,
		},
	];

	return (<>
		<Card style={{marginBottom:"15px"}}>
			
				<Statistic
					title={"Остаток по счету:"}
					value={volume}
					groupSeparator=" "
					precision={2}
					valueStyle={{ color: (volume < 0) ? '#cf1322' : '#3f8600' }}
					suffix="руб."
				/>
			
		</Card>

		<Segmented
			defaultValue="dvizheniya"
			style={{
				marginBottom: 8,
			}}
			onChange={(value) => setPanel(value)}
			options={[
				{
					label: 'Движения денег',
					value: 'dvizheniya',
					disabled: false,
				},
				{
					label: 'Реестр остатков',
					value: 'ostatki',
					disabled: false,
				},
			]}
		/>
		{(account && panel === "dvizheniya") &&
			<CollectionServer
				auth={auth}
				name={"DvizheniyaDeneg"}
				queryDetail={"collection"}
				source={`/api/dvizheniyadeneg/byaccount/${account.akkaunt.ID}`}
				filters={filters}
				size={"small"}
				mode={"list"}
				customRender={(items, {
					collection,
					setCollection,
					setCollectionItem,
					removeCollectionItem,
					collectionActions,
					modelActions,
					update
				}) => (<div>
					{(items?.length <= 0) && <div><Empty description={"Нет данных"} style={{ padding: "40px 0px" }} /></div>}
					{JSXMap(items, (item, idx) => {
						return (<div key={item.ID || idx} style={{ width: "100%" }}>
							<div className={classes.item}>
								<div style={{ flex: "0 0 25px" }}>
									{(item.prikhodID == account.akkaunt.ID && item?.prikhodID) && <Icofont icon="caret-up" style={{ color: "green" }} />}
									{(item?.ukhodID && item.ukhodID == account.akkaunt.ID) && <Icofont icon="caret-down" style={{ color: "red" }} />}
									{((item.prikhodID !== account.akkaunt.ID && item?.prikhodID) && (item?.ukhodID && item.ukhodID !== account.akkaunt.ID)) && <Icofont icon="rounded-expand" rotate='90' style={{ color: "grey" }} />}
								</div>
								<div style={{ flex: "1 1 auto", fontWeight: "400", fontSize: "14px" }}>
									<div>
										{(!item?.ukhodID && item?.prikhodID) && <span>
											Зачисление денежных средств {(item?.osnovanie?.ownerType == 'ekvairing') && <span>(эквайринг)</span>}
											<Icofont icon="long-arrow-right" />
											<span><span>№{item?.prikhodNomer}</span> <span style={{ color: "#6a6a6a" }}>{item?.prikhod?.accountInfo?.vladelets}</span></span>
										</span>}
										{(item?.ukhodID && !item?.prikhodID) && <span>
											<span><span>№{item?.ukhodNomer}</span> <span style={{ color: "#6a6a6a" }}>{item?.ukhod?.accountInfo?.vladelets}</span></span>
											<Icofont icon="long-arrow-right" />
											Вывод денежных средств
										</span>}

										{(item?.ukhodID && item?.prikhodID) && <span>
											<span><span>№{item?.ukhodNomer}</span> <span style={{ color: "#6a6a6a" }}>{item?.ukhod?.accountInfo?.vladelets}</span></span>
											<Icofont icon="long-arrow-right" />
											<span><span>№{item?.prikhodNomer}</span> <span style={{ color: "#6a6a6a" }}>{item?.prikhod?.accountInfo?.vladelets}</span></span>
										</span>}
									</div>
									<div style={{ fontWeight: "300", fontSize: "12px" }}>{item?.opisanie} </div>
								</div>
								<div style={{ flex: "0 0 150px" }}>
									<div style={{ alignSelf: "flex-start", color: "#7c7c7c", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "400", fontSize: "11px" }}>
										Сумма:
									</div>
									<div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "14px" }}>
										{(item.prikhodID == account.akkaunt.ID) && getCurrencyValue(item?.summa, "green")}
										{(item.ukhodID == account.akkaunt.ID) && getCurrencyValue(-1 * item?.summa, "red")}
										{(item.prikhodID !== account.akkaunt.ID && item.ukhodID !== account.akkaunt.ID) && getCurrencyValue(item?.summa, "black")}
									</div>
								</div>
							</div>
						</div>)
					})}
				</div>)}
			/>
		}
		{(account && panel === "ostatki") && <OstatkiPoSchetu auth={auth} object={account?.akkaunt} />}
	</>);
}

export default function CommonMainMyaccount(props) {
	const classes = useStyles();
	const auth = useAuth();
	const dispatch = useDispatch();

	const meta = useSelector(state => state.meta);

	const user = useSelector(state => state.home.user);
	const role = useSelector(state => state.home.role, () => { });
	const role_by_id = useSelector(state => state.home.role_by_id);
	const role_by_name = useSelector(state => state.home.role_by_name);

	// const [tickets, setTickets] = React.useState();

	const akkauntiPolzovatelei = useSelector(REDUX_AkkauntiPolzovatelei.selector.array);

	// AkkauntiPolzovatelei - Аккаунты пользователей
	// AkkauntiShkol - Аккаунты школ
	// AkkauntiRegionalnikhOtdelenii - Аккаунты региональных отделений
	// AkkauntiOrganizatorov - Аккаунты организаторов
	// AkkauntiFed - Аккаунт федерации
	// AkkauntiMeropriyatii - Аккаунты мероприятий
	// console.log(role_by_name);

	useEffect(() => {
		// GET(auth, "/api/ticket/actual", ({ data }) => {
		// 	if (data) {
		// 		setTickets(data);
		// 	}
		// }, errorCatch)
		READWITH(auth, "AkkauntiPolzovatelei", [
			QueryOrder("akkaunt.akkauntType.ID", "ASC"),
			QueryDetail("model")
		], ({ data }) => {
			if (data) {
				dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray(data));
			}
		}, errorCatch);
	}, []);

	const items = useMemo(() => akkauntiPolzovatelei.map((e, i) => ({

		key: i,
		label: (<div>
			<div style={{ fontSize: "12px", color: "grey" }}>
				{(e?.akkaunt?.akkauntTypeID == 2) && <span>Основной счет</span>}
				{(e?.akkaunt?.akkauntTypeID == 9) && <span>Накопительный счет</span>}
			</div>
			<div>
				<span>№{e?.akkaunt?.nomerAkkaunta}</span>
			</div>
		</div>),
		children: <Account key={i} auth={auth} account={e} />,

	})), akkauntiPolzovatelei);

	return (
		<PageLayout hideBreadcrumbs={true}>
			<div style={{ backgroundColor: "white", borderRadius: "4px" }}>
				<div style={{ padding: "10px" }}>
					<Row gutter={[5, 5]} style={{ paddingBottom: "20px" }}>
						<Col span={24}>
							<Tabs defaultActiveKey="1" items={items} />
							{/* {JSXMap(akkauntiPolzovatelei, (e, idx) => <Account key={idx} auth={auth} account={e} />)} */}
							<div>

							</div>
						</Col>
					</Row>
				</div>
			</div>
		</PageLayout>
	);
}
